import React from 'react';
import "../css/RechargePlansPage.css";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function FeaturesPage() {
    const navigate = useNavigate();
    return (

        <div className="features-container">
            <Helmet>
                {/* Page Title */}
                <title>Features | Matka Jantri Calculator Capabilities & Benefits</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Discover all the powerful features of the Matka Jantri calculator. Learn how it helps track bets, manage records, and simplify Matka gameplay."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pushpabetfair.com/features" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Features | Matka Jantri Calculator Capabilities & Benefits" />
                <meta
                    property="og:description"
                    content="Discover all the powerful features of the Matka Jantri calculator. Learn how it helps track bets, manage records, and simplify Matka gameplay."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://pushpabetfair.com/features" />
                <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
            </Helmet>


            <div className="wrapper" style={{ marginTop: -35 }}>
                <div className="section">
                    <div className="top_navbar" style={{ height: "60px", zIndex: 1000 }}>
                        <div className="hamburger">
                            <button
                                className="back_btn"
                                onClick={() => navigate("/game")}
                                aria-label="Go back"
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>
                        </div>
                        <div className="gameName">Jantri APK Info</div>
                    </div>
                </div>
            </div>

            <div className='contentsContainer'>
                {/* Feature 1: Image Left, Content Right */}
                <div className="feature-section normal">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/homePage.png"
                            alt="Jantri Home Page Illustration"
                            loading="lazy"
                        />
                    </div>

                    <div className="feature-content">
                        <h2>Jantri Home Page</h2>

                        {/* Hindi Section */}
                        <div className="section">
                            <strong>हिंदी:</strong>
                            <p><strong>मुख्य सुविधाएँ:</strong></p>
                            <ul>
                                <li><strong>क्लाइंट और गेम चयन:</strong> पहले क्लाइंट और फिर गेम चुनें, फिर शर्त लगाएं।</li>
                                <li><strong>शर्त लगाने के प्रकार:</strong>
                                    <ul>
                                        <li>
                                            <strong>हरुफ़:</strong> A.H, B.H या Booth चुनें → 0 से 9 तक कोई अंक चुनें → राशि दर्ज करें → हर नंबर पर कितनी राशि लगी, यह दिखेगा। → राशि भरें और "Done" दबाएं।
                                        </li>
                                        <li>
                                            <strong>स्ट्रिंग शर्त:</strong> टेलीग्राम/व्हाट्सएप से स्ट्रिंग चिपकाएं (जैसे 01,02,03(30)) → राशि ब्रैकेट में होनी चाहिए। "पलट" से उलटे नंबर लगाएं → "Clear" से इनपुट हटाएं। → राशि भरें और "Done" दबाएं।
                                        </li>
                                        <li>
                                            <strong>क्रॉसिंग शर्त:</strong> जैसे 12 डालने पर मिलेंगे: 11, 12, 21, 22। "जोड़ कट" से 11, 22 हट सकते हैं। → राशि भरें और "Done" दबाएं।
                                        </li>
                                        <li>
                                            <strong>बाट्टा क्रॉसिंग:</strong> दो नंबर दें (जैसे 12 और 34) → मिलेगा: 13, 14, 23, 24। → राशि भरें और "Done" दबाएं।
                                        </li>
                                        <li>
                                            <strong>लड़ी शर्त:</strong> जैसे 11 से 15 → शर्त लगेगी 11, 12, 13, 14, 15 पर → राशि भरें और "Done" दबाएं।
                                        </li>
                                    </ul>
                                </li>
                                <li><strong>वॉलेट और सारांश:</strong> कुल राशि वॉलेट में दिखेगी। 1–100 और 0–9 नंबरों पर लगी राशि भी दिखेगी।</li>
                                <li><strong>फुटर विकल्प:</strong>
                                    <ul>
                                        <li>जंत्री: पुराने दिन की शर्तें देखें</li>
                                        <li>शो एंड कट: कट पेज पर जाएं</li>
                                        <li>अपडेट रिज़ल्ट: गेम का रिज़ल्ट अपडेट करें</li>
                                        <li>जंत्री हटाएं: सभी शर्तें और प्रविष्टियाँ हटाएं</li>

                                    </ul>
                                </li>
                            </ul>
                        </div>

                        {/* English Section */}
                        <div className="section">
                            <strong>English:</strong>
                            <p><strong>Main Features:</strong></p>
                            <ul>
                                <li><strong>Client and Game Selection:</strong> Choose a client → Select a game → Place bets.</li>
                                <li><strong>Types of Bets:</strong>
                                    <ul>
                                        <li>
                                            <strong>Haruf Bet:</strong> Select A.H, B.H, or Booth → Choose digit (0–9) → Enter amount → Amount per digit is shown → Enter amount and click "Done".
                                        </li>
                                        <li>
                                            <strong>String Bet:</strong> Paste input (e.g., 01,02,03(30)) → Amount must be in brackets → Use "Palat" for reversed numbers → Use "Clear" to reset → Enter amount and click "Done".
                                        </li>
                                        <li>
                                            <strong>Crossing Bet:</strong> Input 12 → Output: 11, 12, 21, 22 → "Joda Cut" removes 11, 22 → Enter amount and click "Done".
                                        </li>
                                        <li>
                                            <strong>Batta Crossing:</strong> Input 12 and 34 → Output: 13, 14, 23, 24 → Enter amount and click "Done".
                                        </li>
                                        <li>
                                            <strong>Ladi Bet:</strong> Input 11 to 15 → Places bet on: 11, 12, 13, 14, 15 → Enter amount and click "Done".
                                        </li>
                                    </ul>
                                </li>
                                <li><strong>Wallet and Summary:</strong> Total wallet amount shown. Bet summary for numbers 1–100 and Haruf digits (0–9) shown.</li>
                                <li><strong>Footer Options:</strong>
                                    <ul>
                                        <li>Jantri: View past bets</li>
                                        <li>Show & Cut: Go to cut page</li>
                                        <li>Update Result: Update game result</li>
                                        <li>Delete Jantri: Clear client and game bets</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                {/* edit client  */}

                <div className="feature-section reverse">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/addClient.png"
                            alt="Jantri add client page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Client Management</h2>

                        {/* Hindi Section */}
                        <div className="section">
                            <strong>हिंदी:</strong>
                            <p><strong>यह पृष्ठ आपको 4 विकल्प प्रदान करेगा:</strong></p>
                            <ul>
                                <li><strong>क्लाइंट का नाम:</strong> क्लाइंट का नाम भरें।</li>
                                <li><strong>LC:</strong> LC भरें।</li>
                                <li><strong>Passing Rate:</strong> Passing Rate भरें।</li>
                                <li><strong>Patti:</strong> Patti भरें।</li>
                            </ul>
                            <p><strong>फिर, सभी जानकारी भरने के बाद "Submit" पर क्लिक करें।</strong></p>
                            {/* Instruction Text for Submit */}
                            <p><em>कृपया "Submit" पर क्लिक करने के लिए आवश्यक जानकारी भरें।</em></p>
                            <p><strong>जमा करने के बाद:</strong> सभी क्लाइंट की सूची नीचे दिखाई जाएगी और उनके विवरण के साथ एक "Edit" विकल्प भी होगा, जिससे आप क्लाइंट के विवरण को संपादित कर सकते हैं।</p>

                            {/* Client List and Edit Option */}
                            <div className="client-list">
                                <h3>क्लाइंट की सूची</h3>
                                {/* Example Client */}
                                <ul>
                                    <li>
                                        <strong>Client Name:</strong> XYZ <br />
                                        <strong>LC:</strong> 10% <br />
                                        <strong>Passing Rate:</strong> 85% <br />
                                        <strong>Patti:</strong> 11 <br />
                                        {/* Instruction Text for Edit */}
                                        <p><em>यदि आप क्लाइंट के विवरण को संपादित करना चाहते हैं, तो "Edit" पर क्लिक करें।</em></p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* English Section */}
                        <div className="section">
                            <strong>English:</strong>
                            <p><strong>This page will provide you with 4 options:</strong></p>
                            <ul>
                                <li><strong>Client Name:</strong> Enter the client’s name.</li>
                                <li><strong>LC:</strong> Enter the LC value.</li>
                                <li><strong>Passing Rate:</strong> Enter the passing rate.</li>
                                <li><strong>Patti:</strong> Enter the Patti value.</li>
                            </ul>
                            <p><strong>After filling all the details, click on "Submit".</strong></p>
                            {/* Instruction Text for Submit */}
                            <p><em>Please fill out all the necessary information and then click on "Submit".</em></p>
                            <p><strong>After submission:</strong> You will see the list of all added clients below, along with an "Edit" option to modify client details.</p>

                            {/* Client List and Edit Option */}
                            <div className="client-list">
                                <h3>Client List</h3>
                                {/* Example Client */}
                                <ul>
                                    <li>
                                        <strong>Client Name:</strong> XYZ <br />
                                        <strong>LC:</strong> 10% <br />
                                        <strong>Passing Rate:</strong> 85% <br />
                                        <strong>Patti:</strong> 11 <br />
                                        {/* Instruction Text for Edit */}
                                        <p><em>If you want to edit client details, click on "Edit".</em></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>



                {/* Feature 3: Image Left, Content Right */}
                <div className="feature-section normal">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/AddGame.png"
                            alt="Jantri add game page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Add Game</h2>

                        {/* Hindi Description */}
                        <p><strong>हिंदी:</strong></p>
                        <p>इस पृष्ठ पर आप नया गेम जोड़ सकते हैं। इसके लिए दो इनपुट बॉक्स दिए गए हैं:</p>
                        <ul>
                            <li><strong>Game Name (Full Name)*:</strong> यहाँ पूरे गेम का नाम दर्ज करें।</li>
                            <li><strong>Game Name (Short Name)*:</strong> गेम का छोटा नाम दर्ज करें, जो संक्षिप्त रूप में दिखाया जाएगा।</li>
                        </ul>
                        <p>दोनों जानकारी भरने के बाद "Submit" पर क्लिक करके गेम को जोड़ सकते हैं।</p>

                        {/* English Description */}
                        <p><strong>English:</strong></p>
                        <p>This page allows you to add a new game. It contains two input fields:</p>
                        <ul>
                            <li><strong>Game Name (Full Name)*:</strong> Enter the full name of the game.</li>
                            <li><strong>Game Name (Short Name)*:</strong> Enter a short name (abbreviation) for the game.</li>
                        </ul>
                        <p>After filling both fields, click on "Submit" to add the game.</p>
                    </div>
                </div>



                {/* Feature 2: Image Right, Content Left */}
                <div className="feature-section reverse">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/sideBar.png"
                            alt="Jantri sidebar overview"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Sidebar Features</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी: English:</strong></p>
                        <p>साइडबार के ऊपरी भाग में निम्न जानकारी दिखाई जाती है:</p>
                        <p>The top of the sidebar shows the following information:</p>
                        <ul>
                            <li><strong>जोड़ जंत्री:</strong> चयनित क्लाइंट और गेम के आधार पर शर्तों का सारांश।</li>
                            <li><strong>Matka Jantri:</strong> Summary of bets based on selected client and game</li>
                            <li><strong>यूज़र प्रोफ़ाइल नाम</strong> और <strong>कुल शर्त राशि</strong>।</li>
                            <li><strong>User Profile Name</strong> and <strong>Total Bet Amount</strong></li>
                        </ul>

                        <p>नीचे दिए गए मुख्य विकल्प उपलब्ध हैं:</p>
                        <p>The sidebar includes these key features:</p>
                        <ul>
                            <li>Add Client – नया क्लाइंट जोड़ें</li>
                            <li>Edit Client – मौजूदा क्लाइंट की जानकारी संपादित करें</li>
                            <li>Add Game – नया गेम जोड़ें</li>
                            <li>Delete Game – गेम को हटाएं</li>
                            <li>Delete Client – क्लाइंट को हटाएं</li>
                            <li>Recharge Plans – रिचार्ज योजनाएं देखें</li>
                            <li>Recharge Status – रिचार्ज स्थिति जांचें</li>
                            <li>Hisab Kitab – हिसाब किताब पृष्ठ</li>
                            <li>Laser Book – लेज़र बुक रिपोर्ट</li>
                            <li>User Bets – यूज़र द्वारा लगाई गई शर्तें</li>
                            <li>Lain Dain – लेन-देन विवरण</li>
                            <li>WhatsApp Support – व्हाट्सएप सहायता</li>
                            <li>Join Telegram – टेलीग्राम से जुड़ें</li>
                            <li>Help and Support – सहायता और समर्थन</li>
                            <li>APK Info – एपीके संबंधित जानकारी</li>
                            <li>Logout – लॉग आउट करें</li>
                        </ul>

                        {/* English Section */}


                    </div>
                </div>
                {/* Feature 3: Image Left, Content Right */}
                <div className="feature-section normal">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/rechargePlan.png"
                            alt="Recharge plan illustration"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Recharge Plans</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>जोड़ जंत्री यूज़र के लिए विभिन्न रिचार्ज प्लान उपलब्ध होते हैं। यूज़र किसी भी प्लान को चुनकर रिचार्ज प्रक्रिया शुरू कर सकता है। चयन के बाद यूज़र डिपॉजिट पेज पर रीडायरेक्ट हो जाएगा।</p>
                        <p><strong>स्टेप्स:</strong></p>
                        <ol>
                            <li>QR कोड का स्क्रीनशॉट लें या उसे स्कैन करें।</li>
                            <li>आपने जो राशि भेजी है, वह राशि और ट्रांजेक्शन आईडी दर्ज करें।</li>
                            <li>सभी विवरण भरने के बाद "Submit" पर क्लिक करें।</li>
                            <li>तेज़ अप्रूवल के लिए WhatsApp पर "Continue" संदेश भेजें।</li>
                        </ol>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>Matka Jantri users have access to multiple recharge plans. A user can click on a desired plan to begin the recharge process. After selecting a plan, they are redirected to the deposit page.</p>
                        <p><strong>Steps:</strong></p>
                        <ol>
                            <li>Take a screenshot of the QR code or scan it.</li>
                            <li>Enter the amount and transaction ID for the payment.</li>
                            <li>After entering the details, click on "Submit".</li>
                            <li>For faster approval, send a "Continue" message on WhatsApp.</li>
                        </ol>
                    </div>
                </div>



                {/* Feature 2: Image Right, Content Left */}
                <div className="feature-section reverse">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/jantriCutting.png"
                            alt="Jantri cutting page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Jantri Cutting</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>यह पृष्ठ जोड़ जंत्री यूज़र को किसी भी चयनित क्लाइंट और गेम के लिए जंत्री शर्तों में से कुछ राशि "कट" करने की सुविधा देता है।</p>
                        <p><strong>उदाहरण:</strong> यदि आपने क्लाइंट और गेम चुना है और शर्तें इस प्रकार हैं:</p>
                        <ul>
                            <li>नंबर 11 → ₹200</li>
                            <li>नंबर 12 → ₹250</li>
                            <li>हरूफ़ 1 → ₹300</li>
                            <li>हरूफ़ 2 → ₹100</li>
                        </ul>
                        <p>अब यदि आप जंत्री कटिंग में नंबर के लिए ₹100 और हरूफ़ के लिए ₹100 दर्ज करते हैं, तो यह शेष राशि इस प्रकार दिखाएगा:</p>
                        <ul>
                            <li>नंबर कटिंग के बाद: 11(100), 12(150)</li>
                            <li>हरूफ़ कटिंग के बाद: 1(200), 2(0)</li>
                        </ul>
                        <p>आपको हर कटिंग परिणाम के साथ एक "Copy" विकल्प भी दिखाई देगा जिससे आप संशोधित शर्तों की स्ट्रिंग को कॉपी कर सकते हैं।</p>
                        <p>यह पृष्ठ होम पेज की तरह 1 से 100 तक की शर्तों और हरूफ़ 0–9 की पूरी जानकारी भी दिखाता है।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>This page allows Matka Jantri users to cut down bet amounts from Jantri for a selected client and game.</p>
                        <p><strong>Example:</strong> If the selected bets are:</p>
                        <ul>
                            <li>Number 11 → ₹200</li>
                            <li>Number 12 → ₹250</li>
                            <li>Haruf 1 → ₹300</li>
                            <li>Haruf 2 → ₹100</li>
                        </ul>
                        <p>If you enter a cutting value of ₹100 for both numbers and Haruf, the remaining will be shown as:</p>
                        <ul>
                            <li>After number cutting: 11(100), 12(150)</li>
                            <li>After Haruf cutting: 1(200), 2(0)</li>
                        </ul>
                        <p>Next to each result, you'll see a "Copy" option to copy the updated output string easily.</p>
                        <p>This page also shows full bet data from 1 to 100 and Haruf (0–9), just like the Home Page.</p>
                    </div>
                </div>

                {/* Feature 3: Image Left, Content Right */}
                <div className="feature-section normal">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/jantriBetHistory.png"
                            alt="Jantri bet history page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Jantri Bet History</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>यह पृष्ठ यूज़र्स को शर्तों का इतिहास देखने और गलती से लगी शर्तों को हटाने की सुविधा देता है।</p>
                        <p>दो फ़िल्टर मौजूद हैं:</p>
                        <ul>
                            <li><strong>क्लाइंट चुनें:</strong> उस क्लाइंट को चुनें जिसकी शर्तें देखनी हैं।</li>
                            <li><strong>गेम चुनें:</strong> संबंधित गेम को चुनें।</li>
                        </ul>
                        <p>यदि जोड़ जंत्री यूज़र को किसी शर्त को हटाना है (जैसे कि गलती से लगाई गई हो), तो वह इस पृष्ठ पर जाकर उसे हटा सकता है।</p>
                        <p>जब कोई शर्त हटाई जाती है, तो उससे संबंधित सभी शर्तों को स्वतः रिवर्स कर दिया जाता है।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>This page allows users to view their betting history and delete any bets that may have been placed by mistake.</p>
                        <p>It includes two filters:</p>
                        <ul>
                            <li><strong>Select Client:</strong> Choose the client whose bets you want to review.</li>
                            <li><strong>Select Game:</strong> Select the related game.</li>
                        </ul>
                        <p>If a Matka Jantri user wants to delete a wrongly placed bet, they can do so on this page.</p>
                        <p>Once a bet is deleted, all associated bets are automatically reversed in the system.</p>
                    </div>
                </div>


                {/* Feature 2: Image Right, Content Left */}
                <div className="feature-section reverse">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/updateGameResult.png"
                            alt="Update game result page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Update Game Result</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>यह टैब गेम का परिणाम अपडेट करने के लिए है।</p>
                        <p><strong>मुख्य फ़ील्ड:</strong></p>
                        <ul>
                            <li><strong>Select Date*:</strong> जिस दिन का परिणाम अपडेट करना है, वह तारीख चुनें।</li>
                            <li><strong>Game Name:</strong> गेम की सूची दिखाई जाती है, और साथ में उस गेम का परिणाम भी दिखाई देता है।</li>
                        </ul>
                        <p>अगर परिणाम अपडेट नहीं हुआ है, तो क्रॉस चिन्ह (❌) दिखाई देगा। यदि परिणाम पहले से मौजूद है, तो उसमें नंबर दिखेगा।</p>

                        <p><strong>परिणाम अपडेट करने के लिए:</strong></p>
                        <ul>
                            <li><strong>Select Game*:</strong> नीचे दिए गए ड्रॉपडाउन से गेम चुनें।</li>
                            <li><strong>Result*:</strong> 1 से 100 के बीच कोई भी नंबर डालें।</li>
                            <li>सभी विवरण भरने के बाद "Update Result" पर क्लिक करें।</li>
                        </ul>
                        <p><strong>नोट:</strong> केवल तब परिणाम अपडेट करें जब संबंधित जंत्री भर दी गई हो।</p>
                        <p>अगर आपने गलती से गलत परिणाम भर दिया है, तो कोई चिंता नहीं। आप या तो "Reset Result" का विकल्प चुन सकते हैं या ऊपर के समान प्रक्रिया से परिणाम को फिर से अपडेट कर सकते हैं।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>This tab is used to update the result for a specific game.</p>
                        <p><strong>Main fields:</strong></p>
                        <ul>
                            <li><strong>Select Date*:</strong> Choose the date for which the result needs to be updated.</li>
                            <li><strong>Game Name:</strong> Shows the list of games with their result status.</li>
                        </ul>
                        <p>If the result is not updated yet, a ❌ icon is shown. If it is already updated, the result number is displayed.</p>

                        <p><strong>To update the result:</strong></p>
                        <ul>
                            <li><strong>Select Game*:</strong> Choose a game from the dropdown at the bottom.</li>
                            <li><strong>Result*:</strong> Enter a number between 1 and 100.</li>
                            <li>After filling the required fields, click on "Update Result".</li>
                        </ul>
                        <p><strong>Note:</strong> Make sure to update the result only after filling the Jantri.</p>
                        <p>If you accidentally updated the wrong result, don’t worry — you can either use the "Reset Result" option or simply update the result again using the same steps.</p>
                    </div>
                </div>

                {/* Feature 3: Image Left, Content Right */}
                <div className="feature-section normal">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/lainDain.png"
                            alt="Lain Dain (payment settlement) page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Lain Dain</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>यह पेज उन क्लाइंट्स के लिए बनाया गया है जो किसी गेम में लाभ (Profit) या हानि (Loss) में हैं। उनके हिसाब से या तो पैसे लेने होते हैं या देने होते हैं।</p>
                        <p><strong>फ़ॉर्म विवरण:</strong></p>
                        <ul>
                            <li><strong>Select Client*:</strong> जिस क्लाइंट का भुगतान दर्ज करना है, उसे चुनें।</li>
                            <li><strong>Payment Type*:</strong> "Receive" (पैसे लेना) या "Pay" (पैसे देना) चुनें।</li>
                            <li><strong>Receive Type*:</strong> भुगतान का तरीका चुनें – "Online" या "Offline"।</li>
                            <li><strong>Amount:</strong> राशि दर्ज करें।</li>
                        </ul>
                        <p>सभी विवरण भरने के बाद, आप "Save Payment" विकल्प का उपयोग करके लेन-देन को सहेज सकते हैं।</p>

                        <p><strong>लेन-देन इतिहास:</strong> नीचे की सूची में सभी Lain Dain रिकॉर्ड्स दिखेंगे।</p>
                        <p><strong>फिल्टर:</strong> "Filter By Client" विकल्प का उपयोग करके किसी भी क्लाइंट का इतिहास फ़िल्टर किया जा सकता है।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>This page is used to manage payments for clients who are either in profit or loss for any game. Based on the result, the client either receives money or needs to pay.</p>
                        <p><strong>Form Fields:</strong></p>
                        <ul>
                            <li><strong>Select Client*:</strong> Choose the client whose transaction you want to record.</li>
                            <li><strong>Payment Type*:</strong> Choose either "Receive" (money to be received) or "Pay" (money to be paid).</li>
                            <li><strong>Receive Type*:</strong> Choose "Online" or "Offline" to indicate how the payment was handled.</li>
                            <li><strong>Amount:</strong> Enter the transaction amount.</li>
                        </ul>
                        <p>After filling the details, you can use the "Save Payment" option to store the transaction.</p>

                        <p><strong>Transaction History:</strong> All Lain Dain records will be displayed in the list below.</p>
                        <p><strong>Filter:</strong> You can filter the list by client using the "Filter By Client" option.</p>
                    </div>
                </div>


                {/* Feature 2: Image Right, Content Left */}
                <div className="feature-section reverse">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/hisabKitab.png"
                            alt="Hisab Kitab summary page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Hisab Kitab</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>यह पृष्ठ सभी क्लाइंट्स का हिसाब-किताब दिखाने के लिए बनाया गया है।</p>
                        <p><strong>मुख्य फ़िल्टर:</strong></p>
                        <ul>
                            <li><strong>क्लाइंट चुनें:</strong> किसी विशेष क्लाइंट का हिसाब देखने के लिए उपयोग करें।</li>
                            <li><strong>तारीख चुनें (dd/mm/yyyy):</strong> किसी विशेष दिन का हिसाब देखने के लिए फ़िल्टर करें।</li>
                        </ul>
                        <p>यदि कोई क्लाइंट चयनित नहीं है, तो सभी क्लाइंट्स का हिसाब एक साथ दिखाया जाएगा।</p>
                        <p>पृष्ठ के नीचे एक <strong>"Total"</strong> सेक्शन होता है जो कुल लाभ, हानि या लेनदेन का सारांश दिखाता है।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>This page is used to display the complete financial summary (Hisab Kitab) of clients.</p>
                        <p><strong>Main Filters:</strong></p>
                        <ul>
                            <li><strong>Select Client:</strong> Use this to view Hisab for a specific client.</li>
                            <li><strong>Select Date (dd/mm/yyyy):</strong> Filter the data based on a specific date.</li>
                        </ul>
                        <p>If no client is selected, the summary will show data for all clients combined.</p>
                        <p>At the bottom, there’s a <strong>"Total"</strong> section which shows a complete overview of all profits, losses, and transactions.</p>
                    </div>
                </div>

                {/* Feature 3: Image Left, Content Right */}
                {/* Feature: Delete Jantri - Image Left, Content Right */}
                <div className="feature-section normal">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/deleteJantri.png"
                            alt="Delete Jantri sheet"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Delete Jantri</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>सभी जंत्री प्रोसेस के बाद, अब दिन की शर्तों को साफ़ करने की बारी आती है। इस पेज पर नीचे दिए गए दो विकल्प होते हैं:</p>
                        <ul>
                            <li><strong>Select Client*:</strong> वह क्लाइंट चुनें जिसकी जंत्री हटानी है।</li>
                            <li><strong>Select Game*:</strong> उस क्लाइंट का गेम चुनें जिसकी शर्तें हटानी हैं।</li>
                        </ul>
                        <p>क्लाइंट और गेम चुनने के बाद, "Delete Jantri" विकल्प पर क्लिक करके उस दिन की जंत्री शीट को साफ़ किया जा सकता है।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>After completing all the Jantri processes, this section allows you to clear the bets for the day. You will see the following options:</p>
                        <ul>
                            <li><strong>Select Client*:</strong> Choose the client whose Jantri you want to delete.</li>
                            <li><strong>Select Game*:</strong> Select the specific game of that client.</li>
                        </ul>
                        <p>Once both client and game are selected, use the "Delete Jantri" option to clear the Jantri sheet for that client and game.</p>
                    </div>
                </div>


                {/* Feature 2: Image Right, Content Left */}
                <div className="feature-section reverse">
                    <div className="feature-image">
                        <img
                            src="https://app.matkajantri.com/JantriImage/helpAndSupport.png"
                            alt="Help and Support page"
                            loading="lazy"
                        />
                    </div>
                    <div className="feature-content">
                        <h2>Help and Support</h2>

                        {/* Hindi Section */}
                        <p><strong>हिंदी:</strong></p>
                        <p>अगर आपको किसी भी प्रकार की सहायता या सुझाव साझा करना है, तो यह पेज आपके लिए है।</p>
                        <p>आप नीचे दिए गए फ़ील्ड भर सकते हैं:</p>
                        <ul>
                            <li><strong>Subject:</strong> अपनी समस्या या प्रश्न का शीर्षक दर्ज करें।</li>
                            <li><strong>Message:</strong> विस्तार से समस्या या सुझाव लिखें।</li>
                        </ul>
                        <p>जानकारी भरने के बाद <em>"Send"</em> विकल्प चुनें।</p>
                        <p>भेजे गए संदेश पृष्ठ के नीचे दिखाई देंगे, जिनकी स्थिति <strong>"Pending" (प्रतीक्षारत) या "Success" (सफल)</strong> के रूप में दर्शाई जाती है।</p>

                        {/* English Section */}
                        <p><strong>English:</strong></p>
                        <p>This page is designed to help you reach out for support or share feedback.</p>
                        <p>Simply fill in the following fields:</p>
                        <ul>
                            <li><strong>Subject:</strong> Enter a short title for your issue or request.</li>
                            <li><strong>Message:</strong> Provide a clear and detailed description of your concern.</li>
                        </ul>
                        <p>Once the information is entered, select the <em>"Send"</em> option to submit.</p>
                        <p>Your submitted messages will appear below, each showing a status such as <strong>"Pending" or "Success"</strong>  depending on its processing stage.</p>
                    </div>
                </div>
                <div className="note-section">
                    <h3>📌 Note:</h3>
                    <p>
                        This application is a <strong>Matka Market Calculator APK</strong> designed to simplify and manage your daily <em>hisaab</em> (accounts) across various Matka markets. It provides an easy-to-use interface where users can:
                    </p>
                    <ul>
                        <li>🔢 <strong>Calculate daily hisaab</strong> quickly and accurately.</li>
                        <li>📊 <strong>Track and manage records</strong> of multiple Matka markets.</li>
                        <li>👤 <strong>Maintain personal user data</strong> securely, helping you stay organized.</li>
                        <li>📅 <strong>Review daily, weekly, or monthly summaries</strong> to stay on top of your finances.</li>
                        <li>🛠️ Discover <strong>many more useful features</strong> aimed at improving the overall user experience in handling market-related calculations.</li>
                    </ul>
                    <p>
                        Whether you're a regular player or someone who just wants to keep neat records, this tool is built to make your daily calculations easier and more reliable.
                    </p>
                </div>
            </div></div >
    );
}
